/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

import StoreLeftMenu from '../../menu/StoreLeftMenu';
// import Footer from "../../components/Footer";

// import StoreComment from "./StoreComment";
// import StoreList from "./StoreList";
import parse from 'html-react-parser';

class ItemPreview extends PureComponent {
  state = {};
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    return true;
  };

  _back = () => {
    const { history } = this.props;
    history.goBack();
  };
  _close = () => {
    const { previewClose } = this.props.childProps;
    previewClose();
  };
  render() {
    const { content, title, point } = this.props.childProps;
    const { imgUrl } = this.props;
    /*
        const { match } = this.props;
        const store = match.params.store;
        const idx = match.params.idx;
        */
    return (
      <Fragment>
        <div className="content">
          <StoreLeftMenu />

          {/*오른쪽 콘텐츠*/}
          <div className="vod_list_right store_right">
            <div className="vod_list_group">
              <div className="store_wrap">
                {/* 스토어 스토리 */}
                <div className="store_blog">
                  {/* 스토리 상단 */}
                  <div className="blog_top">
                    <h2 className="tit">
                      <button
                        type="button"
                        className="btn_prev"
                        onClick={this._close}
                      >
                        <img
                          src={imgUrl + '/img/store/arrw_pre.svg'}
                          alt="이전"
                        />
                      </button>
                      매장 이야기
                    </h2>
                    <ul className="post_info">
                      <li className="data">
                        {/* 서울 seoul, 대전 daejeon, 광주 gwangju, 부산 busan / */}
                        <span className="writer busan">{point}</span>
                        <span className="date">2022.02.01</span>
                      </li>
                      <li className="social">
                        <ul className="story_social">
                          <li className="story_ico">
                            <span className="ico_like active"></span>
                            <span className="num">0</span>
                          </li>
                          <li className="story_ico">
                            <span className="ico_reply"></span>
                            <span className="num">0</span>
                          </li>
                          <li className="story_ico btn_more">
                            <span className="ico_more"></span>
                            <ul className="more_wrap">
                              <li>
                                <a href="#">
                                  <img
                                    src={imgUrl + '/img/store/sns_fb.png'}
                                    alt="페이스북"
                                  />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <img
                                    src={imgUrl + '/img/store/sns_kako.png'}
                                    alt="카카오"
                                  />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <img
                                    src={imgUrl + '/img/store/sns_google.png'}
                                    alt="구글"
                                  />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <img
                                    src={imgUrl + '/img/store/sns_twt.png'}
                                    alt="트위터"
                                  />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <img
                                    src={imgUrl + '/img/store/sns_naver.png'}
                                    alt="네이버"
                                  />
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  {/* 스토리 본문 */}
                  <div className="blog_container">
                    {/* 스토리 내용 */}
                    <div className="blog_content">
                      <h2 className="subject">{title}</h2>
                      {parse(content)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /220109 store */}
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(ItemPreview)));
